app.factory("PollService", ["$http", "$log",
    function ($http, $log) {
        var PollService = {};

        PollService.sendList = function (params) {
            return $http.get("/poll/list/send", {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 25,
                    query: params.query,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                    owned: params.owned
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        PollService.send = function (poll) {
            return $http.post("/poll/send", poll).then(function (resp) {
                return resp.data;
            });
        };

        PollService.unread = function () {
            return $http.get("/poll/unread").then(function (resp) {
                return resp.data;
            })
        };

        PollService.received = function (params) {
            return $http.get("/poll/received", {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 25
                }
            }).then(function (resp) {
                return resp.data
            })
        };

        PollService.mark = function (params) {
            return $http.post("/poll/mark/" + params.poll, {
                state: params.state,
                answer: params.answer
            }).then(function (resp) {
                return resp.data
            })
        };

        PollService.remove = function (pollId) {
            return $http.post("/poll/remove/" + pollId).then(function (resp) {
                return resp.data
            })
        };

        PollService.getLast = function () {
            return $http.get("/poll/last").then(function (resp) {
                return resp.data
            })
        };

        PollService.getStats = function (params) {
            return $http.get("/poll/stats/" + params.pollId).then(function (resp) {
                return resp.data
            })
        };

        PollService.getAnswers = function (params) {
            return $http.get("/poll/answers/" + params.pollId, {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 25
                }
            }).then(function (resp) {
                return resp.data
            })
        };

        PollService.getById = function (params) {
            return $http.get("/poll/one/" + params.pollId).then(function (resp) {
                return resp.data
            })
        };

        return PollService;
    }
]);